import { QUIZ_SUBMISSION_EVENT, RESPONSE, SESSION_STARTED_OR_RESUMED_EVENT, RCE_EVENT, PAGE_BLURRED_EVENT, PAGE_FOCUSED_EVENT } from '@instructure/quiz-common';
import { getBrowserSessionId, getIpAddress } from '../selectors/taking';
import { getActiveQuizSession } from '../selectors/quizSessions';
var whitelist = [QUIZ_SUBMISSION_EVENT, RESPONSE, SESSION_STARTED_OR_RESUMED_EVENT, RCE_EVENT, PAGE_BLURRED_EVENT, PAGE_FOCUSED_EVENT];
export function serializeEvent(action, store) {
  var type = action.type;
  if (!whitelist.includes(type)) {
    return false;
  }
  var state = store.getState();
  var quizSession = getActiveQuizSession(state);
  var defaultEventData = {
    userAgent: navigator.userAgent,
    browserSessionId: getBrowserSessionId(state),
    clientTimestamp: new Date(),
    ipAddress: getIpAddress(state)
  };
  var authoritativeData = {
    accountUuid: quizSession.accountUuid,
    eventCreationToken: quizSession.eventCreationToken,
    eventType: type,
    quizSessionId: quizSession.id,
    rootAccountUuid: quizSession.rootAccountUuid
  };
  return Object.assign({
    eventData: Object.assign({}, action.payload, defaultEventData)
  }, authoritativeData);
}
export default serializeEvent;